/**
 * Section FAQ - JavaScript ULTRA SIMPLE
 * Pas de padding-bottom, le CSS gère tout
 */

const initFAQ = () => {
  const faqSections = document.querySelectorAll('.faq-section');
  
  faqSections.forEach(faqSection => {
    const items = faqSection.querySelectorAll('.faq-section_items .item');
    
    if (items.length === 0) return;

    items.forEach(item => {
      // Gérer le clic
      item.addEventListener('click', (e) => {
        e.preventDefault();
        
        const isOpen = item.hasAttribute('open');
        
        // Fermer tous les autres items (mode accordéon)
        items.forEach(otherItem => {
          if (otherItem !== item && otherItem.hasAttribute('open')) {
            otherItem.removeAttribute('open');
          }
        });
        
        // Toggle l'item cliqué
        if (isOpen) {
          item.removeAttribute('open');
        } else {
          item.setAttribute('open', '');
        }
      });
      
      // Accessibilité clavier
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        }
      });
      
      // Accessibilité
      item.setAttribute('tabindex', '0');
      item.setAttribute('role', 'button');
      item.setAttribute('aria-expanded', 'false');
      
      // Mettre à jour aria-expanded
      const observer = new MutationObserver(() => {
        const isOpen = item.hasAttribute('open');
        item.setAttribute('aria-expanded', isOpen.toString());
      });
      
      observer.observe(item, {
        attributes: true,
        attributeFilter: ['open']
      });
    });
  });
};

// Initialiser au chargement
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFAQ);
} else {
  initFAQ();
}

// Réinitialiser si la page change
document.addEventListener('shopify:section:load', initFAQ);